export default "__VITE_ASSET__C3biV2RB__"